import { Flex, GlobalToken, Typography } from "antd";
import styled from "styled-components";
import type { Icon } from "@phosphor-icons/react";
import { useAntTheme } from "hooks/useAntTheme";
import { radius } from "@libertify/ui";

export type DnaDimensionHeaderProps = Readonly<{
  icon: Icon;
  label: string;
  title: string;
}>;

export const DnaDimensionHeader = ({
  icon: DimensionIcon,
  label,
  title,
}: DnaDimensionHeaderProps) => {
  const { theme } = useAntTheme();

  return (
    <Flex align="center" gap={16}>
      <StyledIcon $token={theme} align="center" justify="center">
        <DimensionIcon size={24} />
      </StyledIcon>
      <Flex vertical>
        <Typography.Text
          type="secondary"
          style={{ fontSize: theme.fontSizeSM }}
        >
          {label}
        </Typography.Text>
        <Typography.Text strong style={{ fontSize: theme.fontSizeLG }}>
          {title}
        </Typography.Text>
      </Flex>
    </Flex>
  );
};

// ─── Styled components ───

const StyledIcon = styled(Flex)<{ $token: GlobalToken }>`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: ${radius.circle};
  background: ${({ $token }) => $token.colorPrimaryBg};
  color: ${({ $token }) => $token.colorPrimary};
`;
